import { useCallback, useState } from "react"
import { State } from "../entities/state"
import { stateListService } from "../services/state/stateListService"
import { useAuth } from "./useAuth"

export function useStateListService(): {
	stateList: State[]
	isLoading: boolean
	error: null | Error
	fetchStateList: (filter?: Parameters<typeof stateListService>[0]) => Promise<void>
} {
	const { token } = useAuth()
	const [stateList, setStateList] = useState<State[]>([])
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState<Error | null>(null)

	const fetchStateList = useCallback(
		async (filter: Parameters<typeof stateListService>[0] = {}) => {
			try {
				setIsLoading(true)
				const data = await stateListService(filter, token)
				setStateList(data)
			} catch (error) {
				setError(error as Error)
			} finally {
				setIsLoading(false)
			}
		},
		[token],
	)

	return { stateList, isLoading, error, fetchStateList }
}
